<template lang="pug">
  #existing-organizations-table
    WtEntityTable(
      title=""
      has-title-large
      :data="organizations || []"
      default-sort-field="id"
      empty-message="No organizations"
      :showEmptyMessage="!organizations.length"
    )
      BTableColumn(
        field="name"
        label="Name"
        v-slot="column"
        sortable
      )
        WtRouterLink(
          to="Organization"
          :params="{ organizationName: column.row.name }"
          :text="column.row.name"
          type="table"
        )
      BTableColumn(
        field="active"
        label="Status"
        v-slot="column"
        sortable
      ) {{ column.row.active ? 'Active' : 'Inactive' }}
      BTableColumn(
        field="membersCount.membersCount"
        label="Members"
        v-slot="column"
        sortable
      ) {{ column.row.membersCount.membersCount }}
      BTableColumn(
        field="adminMember.username"
        label="Organization Admin"
        v-slot="column"
      )
        WtRouterLink(
          v-if="column.row.adminMember"
          to="ProfilePage"
          :params="{ username: column.row.adminMember.username }"
          :text="column.row.adminMember.username"
        )
        span(v-else)
      BTableColumn(
        v-slot="column"
      )
        WtButton.action-button(
          is-text
          bold
          @click.native="openModal(column.row.id)"
          :disable="processing"
        ) Edit
        WtButton.action-button(
          is-text
          bold
          color="grey"
          @click.native="deleteOrganizationModal(column.row)"
          :disable="processing"
        ) Delete
    BModal(
      :active.sync="editModalOpen"
      :width="600"
    )
      EditOrganizationModal(
        @editModalOpen="editModalOpen = $event" 
        :organizationId="editedOrganizationId" 
        :organizationAdmin="editedOrganizationAdmin"
      )
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import EditOrganizationModal from "@@/OrganizationsSettingsAdmin/EditOrganizationModal";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

import { mapActions } from "vuex";

export default {
  name: "ExistingOrganizationsTable",

  components: { WtEntityTable, WtButton, EditOrganizationModal, WtRouterLink },

  mixins: [tablePropsMixin, dateUtilityMixin],

  props: {
    organizations: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      processing: false,
      editModalOpen: false,
      editedOrganizationId: null,
      editedOrganizationAdmin: null
    };
  },
  methods: {
    ...mapActions("organizations", [
      "deleteOrganization",
      "fetchOrganization",
      "setEditedOrganization"
    ]),
    ...mapActions(["snackBar"]),
    async openModal(organizationId) {
      let organization = await this.fetchOrganization({
        organizationId,
        relations: ["members"]
      });
      this.setEditedOrganization(organization);
      const adminOrganization = this.organizations.find(
        org => org.id === organizationId
      );

      this.editedOrganizationId = organizationId;
      this.editedOrganizationAdmin = adminOrganization.adminMember;
      this.editModalOpen = true;
    },
    deleteOrganizationModal(organization) {
      this.processing = true;
      this.$buefy.dialog.confirm({
        title: `Delete ${organization.name}`,
        confirmText: "Delete This Organization",
        type: "is-danger",
        hasIcon: true,
        message: `Are you sure you want delete ${organization.name} organization?`,
        onConfirm: async () => {
          await this.deleteThisOrganization(organization.id);
          this.processing = false;
        },
        onCancel: () => {
          this.processing = false;
        }
      });
    },
    async deleteThisOrganization(organizationId) {
      try {
        await this.deleteOrganization({
          organizationId
        });
        this.snackBar({
          duration: 5000,
          type: "is-success",
          message: `Organization successfully deleted!`
        });
      } catch (err) {
        if (err.status !== 500) {
          this.snackBar({
            type: "is-danger",
            message: err.data.error.message
          });
        } else {
          this.snackBar({
            type: "is-danger",
            message: `There was an error. Please contact wellness@be-engaged.co`
          });
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#existing-organizations-table
  .action-button
    text-decoration: underline !important
</style>
